module.exports = __webpack_public_path__ + "static/media/click-new-connected-app.f49b20c7.gif";